import { Alert as DSAlert } from '@vtex/admin-ui'
import { FormState, getErrorText, hasError } from '@vtex/admin-ui-form'
import { useFormStateContext } from '../../../../../providers'
import { BIN_SUB_FORM_NAME } from '../BINEditor'
import styles from './Alert.css'

type Props = {
  state: FormState
}

export function Alert({ state }: Props) {
  return hasError(state, BIN_SUB_FORM_NAME) ? (
    <DSAlert
      className={styles.alert}
      variant="critical"
      onDismiss={() => state.clearErrors(BIN_SUB_FORM_NAME)}
    >
      {getErrorText(state, BIN_SUB_FORM_NAME)}
    </DSAlert>
  ) : null
}
